<template>
    <div class="wrap-content">
        <div class="filter-section alert-filter row-min-space">
            <div class="row">
                <div class="col-md-12">
                    <h2>Alerts</h2>
                </div>
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-10">
                            <div class="row">
                                <div class="col-xs-12 col-md-3 tabs-bar">
                                    <b-form-group>
                                        <b-form-radio-group
                                            v-model="query.status"
                                            :options="options"
                                            buttons
                                            button-variant="outline-primary"
                                            :name="filterName"
                                            @change="filterTab()"
                                        ></b-form-radio-group>
                                    </b-form-group>
                                </div>
                                <div class="col-xs-12 col-md-9">
                                    <div class="row">
                                        <div class="col-xs-12 col-md-2">
                                            <base-search
                                                placeholder="Search"
                                                @keyword="getKeyword"
                                            ></base-search>
                                        </div>
                                        <div
                                            v-if="user.kyb"
                                            class="col-xs-12 col-md-2"
                                        >
                                            <b-form-group>
                                                <b-form-select
                                                    id="input-3"
                                                    v-model="query.category"
                                                    class="form-control"
                                                    :options="
                                                        filterCategoryOptions
                                                    "
                                                    required
                                                ></b-form-select>
                                            </b-form-group>
                                        </div>
                                        <div class="col-xs-12 col-md-3">
                                            <b-form-group>
                                                <b-form-select
                                                    id="input-3"
                                                    v-model="query.type"
                                                    class="form-control"
                                                    :options="
                                                        filterAlertOptions
                                                    "
                                                    required
                                                ></b-form-select>
                                            </b-form-group>
                                        </div>
                                        <div
                                            :class="{
                                                'col-md-3': user.kyb,
                                                'col-md-4': !user.kyb,
                                            }"
                                        >
                                            <b-form-group>
                                                <b-form-select
                                                    id="input-4"
                                                    v-model="query.riskLevel"
                                                    class="form-control"
                                                    :options="
                                                        filterRiskLevelOptions
                                                    "
                                                ></b-form-select>
                                            </b-form-group>
                                        </div>
                                        <div
                                            :class="{
                                                'col-md-2': user.kyb,
                                                'col-md-3': !user.kyb,
                                            }"
                                        >
                                            <b-form-group>
                                                <b-form-select
                                                    id="input-5"
                                                    v-model="query.aging"
                                                    class="form-control"
                                                    :options="
                                                        filterAgingOptions
                                                    "
                                                ></b-form-select>
                                            </b-form-group>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-1">
                            <div class="form-group">
                                <button
                                    class="btn btn-primary"
                                    :class="
                                        loading && showPageLoader
                                            ? 'disabled'
                                            : ''
                                    "
                                    type="submit"
                                    @click="apply()"
                                >
                                    <span class="btn-text">Apply</span>
                                    <span class="loader"></span>
                                </button>
                            </div>
                        </div>
                        <div class="col-md-1">
                            <b-form-group>
                                <b-button
                                    type="button"
                                    variant="secondary"
                                    class="secondary-add-btn"
                                    @click="exportRecords"
                                >
                                    <span class="btn-text">EXPORT</span>
                                </b-button>
                            </b-form-group>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            :class="[
                'table-section',
                'table-min-width',
                'alert-custom-table',
                {
                    'overflow-hidden': !data.length && !showPageLoader,
                },
            ]"
        >
            <!-- Main table -->
            <b-table
                :items="data"
                :fields="alertsFields"
                no-local-sorting
                :tbody-tr-class="rowClass"
                @sort-changed="sortingChanged"
                @row-clicked="CustomerProfile"
            >
                <!-- Alerts riskLevel -->

                <template slot="riskLevel" slot-scope="data">
                    <div
                        v-b-tooltip.hover
                        class="bar-line"
                        :class="changeBarLineClass(data)"
                        :title="changeBarLineTitle(data)"
                    ></div>
                    <div class="indecation">
                        <div class="alert-type-icons">
                            <span
                                v-show="data.item.isReturned"
                                class="alert-return-icon"
                            >
                                <i class="icon-chevron-down rotate"></i>
                                <i class="icon-chevron-down"></i>
                            </span>
                            <i
                                v-if="data.item.type == 'triggered'"
                                v-b-tooltip.hover
                                class="icon-flag"
                                :style="{
                                    color:
                                        data.item.documentSubmission &&
                                        data.item.documentSubmission ==
                                            'pending'
                                            ? 'yellow'
                                            : data.item.documentSubmission &&
                                              data.item.documentSubmission ==
                                                  'submitted'
                                            ? 'lightgreen'
                                            : '',
                                }"
                                :title="
                                    data.item.isReturned
                                        ? 'Trigger Return Alert'
                                        : 'Trigger Alert'
                                "
                            ></i>
                            <i
                                v-if="data.item.type == 'periodic'"
                                v-b-tooltip.hover
                                class="icon-rotate-inverse"
                                :title="
                                    data.item.isReturned
                                        ? 'Periodic Return Alert'
                                        : 'Periodic Alert'
                                "
                            ></i>
                            <i
                                v-if="data.item.type == 'on_boarding'"
                                v-b-tooltip.hover
                                class="icon-star"
                                :title="
                                    data.item.isReturned
                                        ? 'Onboarding Return Alert'
                                        : 'Onboarding Alert'
                                "
                            ></i>
                            <i
                                v-if="data.item.type == 'manual'"
                                v-b-tooltip.hover
                                class="icon-manual-alert"
                                :title="' Manual alert '"
                            ></i>
                        </div>
                    </div>
                </template>
                <!-- Alerts Type -->

                <!-- Aging -->
                <template slot="createdAt" slot-scope="data">
                    <span :class="agingClass(data.value)">
                        {{ agingFilter(data.value) }}
                    </span>
                </template>

                <!-- Alert Customer Id -->
                <!-- <template slot="idenfoId" slot-scope="data">
                    {{ data.value }}
                </template> -->

                <!-- Alert Nationality -->
                <template
                    v-if="data.item.customer"
                    slot="customer.nationality"
                    slot-scope="data"
                >
                    <div
                        v-for="(alertNationality, index) in data.item &&
                        data.item.customer &&
                        data.item.customer.nationality"
                        :key="index"
                    >
                        {{ alertNationality.title }}
                    </div>
                </template>

                <template slot="profile" slot-scope="data">
                    <div class="profile-area">
                        <div
                            v-if="
                                data.item.customer &&
                                data.item.customer.documentInfo &&
                                data.item.customer.documentInfo.picture &&
                                data.item.customer.documentInfo.picture
                                    .fileName != ''
                            "
                            v-authenticated-image="
                                'customers/' +
                                data.item.customer.documentInfo.picture.fileName
                            "
                            class="profile-pic"
                        ></div>
                        <div
                            v-else
                            class="profile-pic"
                            :style="{
                                'background-image':
                                    'url(' +
                                    require('@/assets/images/dummy/dummy-user.png') +
                                    ')',
                            }"
                        ></div>
                    </div>
                </template>
                <template slot="associatedCompany" slot-scope="data">
                    {{ getAssociateCompanyNames(data.item.customer) }}
                </template>
                <!-- Alert Name Screening Status -->
                <template slot="nameScreeningStatus" slot-scope="data">
                    <div>
                        <name-screening-status :status-type="data.value">
                        </name-screening-status>
                    </div>
                    <!-- <div v-else>
                        <name-screening-status :status-type="low">
                        </name-screening-status>
                    </div> -->
                </template>

                <!-- Alert Documentation Status -->
                <template slot="documentationStatus" slot-scope="data">
                    <alert-type-status
                        :status-type="data.value"
                    ></alert-type-status>
                </template>

                <!-- Alert Risk Rating Status -->
                <template slot="riskRatingStatus" slot-scope="data">
                    <div>
                        <alert-type-status
                            :status-type="alertStatus(data)"
                        ></alert-type-status>
                    </div>
                    <!-- <div v-else>
                        <alert-type-status
                            :status-type="low"
                        ></alert-type-status>
                    </div> -->
                </template>

                <!-- Alert Status -->
                <template slot="data" slot-scope="data">
                    <div class="action-review">
                        <base-action
                            v-if="
                                data.item.status == 'locked' &&
                                hasScopes('unlock-alerts')
                            "
                            v-b-tooltip.hover
                            icon="icon-lock_outline"
                            class="disable-color"
                            label="Unlock"
                            :title="
                                data.item.user &&
                                'In Review by' +
                                    ' ' +
                                    data.item.user.firstName +
                                    ' ' +
                                    data.item.user.lastName
                            "
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('initiate-review-popup')
                            "
                        ></base-action>
                        <base-action
                            v-if="
                                data.item.status == 'locked' &&
                                !hasScopes('unlock-alerts')
                            "
                            v-b-tooltip.hover
                            icon="icon-lock_outline"
                            class="disable-color"
                            label="In Review"
                            :title="
                                data.item.user &&
                                'In Review by' +
                                    ' ' +
                                    data.item.user.firstName +
                                    ' ' +
                                    data.item.user.lastName
                            "
                        ></base-action>
                        <base-action
                            v-if="
                                data.item.status == 'pending' &&
                                data.item.customer.status == 'pending'
                            "
                            :css-class="
                                hasScopes('kyc-status-review') &&
                                (hasScopes('maker') ||
                                    hasScopes('checker') ||
                                    hasScopes('approver')) &&
                                !(data.item.childAlertsResolved === false) // if child parent infection on and child alert not resolved then disable
                                    ? ''
                                    : 'action-review disabled'
                            "
                            icon="icon-review"
                            label="Review"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('initiate-review-popup')
                            "
                        ></base-action>

                        <base-action
                            v-if="data.item.customer.status == 'inactive'"
                            icon="icon-review"
                            label="Review"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('ip-popup')
                            "
                        ></base-action>
                    </div>
                </template>
            </b-table>
            <!-- When data is loading -->
            <base-table-spinner
                v-if="!data.length && showPageLoader"
            ></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found
                v-if="!data.length && !showPageLoader"
            ></base-no-record-found>
        </div>
        <base-records
            path="alerts/"
            :query="query"
            :reset="reset"
            :show-pagination="true"
        ></base-records>
        <initiate-review-popup></initiate-review-popup>
        <export-process-popup
            :id="id"
            title="Export Insight Alert's Data"
            :url="cancelUrl"
        ></export-process-popup>
        <custom-popup
            popup-id="ip-popup"
            size="sm"
            title="Alert"
            :content="`<h6>This customer is inactive kindly activate first! </h6>`"
            ok-message="Close"
        ></custom-popup>
    </div>
</template>

<script>
/* VUE STORE GETTER */
import { mapGetters } from 'vuex'
import _ from 'lodash'

/* REQUIRE MOMENT */
var moment = require('moment')
/* PROJECT COMPONENTS */
import alertTypeStatus from '@/components/BaseAlertType.vue'
import initiateReviewPopup from '@/components/popups/InitiateReviewPopup.vue'
import nameScreeningStatus from '@/components/NameScreeningStatus.vue'
import exportProcessPopup from '@/components/popups/ExportProcessPopup.vue'
import resource from '@/api/resource'
import request from '@/utils/request'
import { capitalize } from 'lodash'
import CustomPopup from '@/components/popups/CustomPopup.vue'

const modulesApi = new resource('configurations/modules')

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        initiateReviewPopup,
        alertTypeStatus,
        nameScreeningStatus,
        exportProcessPopup,
        CustomPopup,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            liveness: null,
            nameScreening: null,
            riskFactor: null,
            showPagination: false,
            showReviewLink: false,
            filterAging: '',

            image: 'dummy/dummy-user.png',

            alertsFields: [
                {
                    key: 'riskLevel',
                    label: 'Type',
                    sortable: true,
                    class: 'min-20',

                    formatter: (value) => {
                        return _.startCase(value)
                    },
                },
                {
                    key: 'profile',
                    label: '',
                    class: 'profile-absolute',
                },
                {
                    key: 'customer.idenfoId',
                    label: 'Idenfo Id',
                    sortable: true,
                },
                {
                    key: 'customer.basicInfo',
                    label: 'NAME',
                    sortable: true,
                    formatter: (value) => {
                        if (value) {
                            return _.startCase(
                                value.firstName                            )
                        }
                    },
                },
                {
                    key: 'customer.nationality',
                    label: 'Country',
                    sortable: false,
                },
                {
                    key: 'customer.type',
                    label: 'Category',
                    sortable: true,
                    formatter: (value) => {
                        if (value) {
                            return _.startCase(value)
                        } else if (value == '' || !value) {
                            return 'Individual'
                        }
                    },
                },
                {
                    key: 'associatedCompany',
                    label: 'Associated Company',
                    sortable: false,
                },
                {
                    key: 'createdAt',
                    label: 'Aging',
                    sortable: true,
                },
                {
                    key: 'nameScreeningStatus',
                    label: 'NAME SCREENING',
                    thClass: 'with-icon person-icon text-center',
                    tdClass: 'text-center',
                },
                {
                    key: 'documentationStatus',
                    label: 'DOCUMENTATION',
                    thClass: 'with-icon document-icon text-center',
                    tdClass: 'text-center',
                },
                {
                    key: 'riskRatingStatus',
                    label: 'RISK RATING',
                    thClass: 'with-icon text-center graph-icon',
                    tdClass: 'text-center',
                },
                {
                    key: 'data',
                    label: 'STATUS',
                    class: 'action',
                    thClass: 'w-120px',
                    sortable: true,
                },
            ],
            query: {
                keyword: '',
                perPage: 10,
                startAt: 1,
                sortBy: 'customerId',
                sortOrder: 'desc',
                riskLevel: null,
                status: null,
                dataSegmentId: null,
                aging: null,
                type: null,
                category: null,
            },
            reset: new Date().getTime(),
            items: [],
            options: [
                { text: 'All', value: null },
                { text: 'Pending', value: 'pending' },
                { text: 'In Review', value: 'locked' },
                // { text: 'Inactive', value: 'inactive' },
            ],
            filterName: null,
            filterByAlert: null,
            filterCategoryOptions: [
                { text: 'All Category', value: null },
                { text: 'Individual', value: 'individual' },
                { text: 'Company', value: 'company' },
            ],
            filterAlertOptions: [
                { text: 'Filter by alert type', value: null },
                { text: 'Trigger alert', value: 'triggered' },
                { text: 'Periodic alert', value: 'periodic' },
                { text: 'Manual alert', value: 'manual' },
                { text: 'Onboarding alert', value: 'on_boarding' },
            ],
            filterByRiskLevel: null,
            filterRiskLevelOptions: [
                { text: 'Filter by risk level', value: null },
                { text: 'High Risk', value: 'high' },
                { text: 'Medium Risk', value: 'medium' },
                { text: 'Low Risk', value: 'low' },
                { text: 'Sanctioned Risk', value: 'sanction' },
            ],
            filterByAging: null,
            filterAgingOptions: [
                { text: 'Filter by aging', value: null },
                { text: '0-30 days', value: '0-30' },
                { text: '31-60 days', value: '31-60' },
                { text: '61-90 days', value: '61-90' },
                { text: '91+ days', value: '91+' },
            ],
            alertlist: [],
        }
    }, // End of Component > data
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'data',
            'showPageLoader',
            'loading',
            'reload',
            'alertsFilteredData',
            'kycRole',
            'hasScopes',
            'user',
        ]),
        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        reload(value) {
            if (value) {
                // this.reset = new Date().getTime()
            }
        },
    },

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getModuleData()

        localStorage.setItem('goBackUrl', this.$route.name)
    }, // End of Component > mounted

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        getAssociateCompanyNames(customer) {
            return customer.parentCompanies && customer.parentCompanies.length
                ? customer.parentCompanies
                      .map((parent) => parent.basicInfo.firstName)
                      .join(', ')
                : customer.occupationInfo && customer.occupationInfo.companyName
                ? customer.occupationInfo.companyName
                : ''
        },
        rowClass(item, type) {
            console.log('item', item.customer.status)
            if (item.customer.status == 'inactive') {
                return 'table-secondary'
            }
            // if (!item || type !== 'row') return
            // if (item.user_id == this.$auth.user.id) return 'table-success'
        },
        changeBarLineTitle(data) {
            let conditions = ['low', null]
            let documentationHighRisks = ['expired', 'expiredIn']
            let documentationSanctionRisks = ['mis_matched']
            let riskRatingStatus = data.item.riskRatingStatus
            let nameScrStatus = data.item.nameScreeningStatus
            let docStatus = data.item.documentationStatus
            return (
                capitalize(
                    conditions.includes(riskRatingStatus) &&
                        conditions.includes(nameScrStatus) &&
                        !conditions.includes(docStatus)
                        ? documentationHighRisks.includes(docStatus)
                            ? 'high'
                            : 'sanction'
                        : riskRatingStatus
                ) + ' Risk'
            )
        },
        changeBarLineClass(data) {
            let conditions = ['low', null]
            let documentationHighRisks = ['expired', 'expiredIn']
            let documentationSanctionRisks = ['mis_matched']
            let riskRatingStatus = data.item.riskRatingStatus
            let nameScrStatus = data.item.nameScreeningStatus
            let docStatus = data.item.documentationStatus
            return conditions.includes(riskRatingStatus) &&
                conditions.includes(nameScrStatus) &&
                !conditions.includes(docStatus)
                ? documentationHighRisks.includes(docStatus)
                    ? 'high'
                    : 'sanction'
                : riskRatingStatus
        },
        async getModuleData() {
            try {
                if (this.dataSegmentId) {
                    let { data } = await modulesApi.list({
                        dataSegmentId: this.dataSegmentId,
                    })
                    if (!_.isEmpty(data.data)) {
                        this.liveness = data.data.liveness
                        this.nameScreening = data.data.nameScreening
                        this.riskFactor = data.data.riskFactor
                        console.log('Liveness', this.liveness)
                    }
                }
            } catch (error) {
                console.log(error)
            }
        },
        async CustomerProfile(record) {
            await this.$store.commit('setAlertRecord', record)
            await localStorage.setItem('alertId', record._id)
            let routeName =
                record.customer.type == 'company'
                    ? 'company-information'
                    : 'customer-information'
            await this.$router
                .push({
                    name: routeName,
                    params: {
                        id: record.customerId,
                    },
                })
                .catch(() => {})
        },
        getKeyword(val) {
            this.query.keyword = val
        }, // End of getKeyword() method

        apply() {
            this.$store.commit('setLoading', true)
            this.reset = new Date().getTime()
        }, // End of apply() method

        filterTab() {
            this.reset = new Date().getTime()
        }, // End of filterTab() method

        selectedRecord(record) {
            this.$store.commit('setAlertRecord', record)
        }, // End of selectedRecord() method

        sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy

            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'
            if (this.query.sortBy) {
                this.apply()
            }
        }, // End of sortingChanged() method

        agingFilter(value) {
            var currentDate = moment()
            var b = moment(value)
            return currentDate.diff(b, 'days') + ' D'
        },
        agingClass(value) {
            var currentDate = moment()
            var b = moment(value)
            let diff = currentDate.diff(b, 'days')
            if (diff <= 30) {
                return 'low'
            }
            if (diff > 30 && diff <= 60) {
                return 'medium'
            }
            if (diff > 60 && diff <= 90) {
                return 'danger'
            }
            if (diff > 90) {
                return 'high'
            }
        },
        imageFilePath(data) {
            if (data && data.picture && data.picture.fileName) {
                return 'customers/' + data.picture.fileName
            }
            return require('@/assets/images/dummy/dummy-user.png')
        },
        alertStatus(data) {
            if (data.item.customer && data.item.customer.diligenceStatus) {
                let nextReviewDate = this.$moment(
                    data.item.customer.diligenceStatus.nextReview
                )
                let diff = nextReviewDate.diff(this.$moment(), 'days')
                if (diff <= 60) {
                    return 'periodic_review_due'
                }
            }
            console.log('RISKFACTOR', data.value)
            return data.value
        },
        async exportRecords() {
            try {
                this.query.dataSegmentId = this.dataSegmentId

                let { data } = await request.post('alerts/export', null, {
                    params: this.query,
                })

                // console.log('data  ' + JSON.stringify(data))

                this.id = data.data.id
                // this.$bvModal.show('export-process-popup')
                this.$toasted.show(data.message, {
                    type: 'success',
                })
            } catch (error) {
                // console.log(error, 'error')
            }
        }, // End of exportRecords() method
    }, // End of Component > methods
} // End of export default
</script>
